import { useList } from "@refinedev/core";
import { useMe } from "@src/hooks/use-me";
import { IProduct } from "@src/types/user";
import AmanotesIcon from "@src/assets/images/amanotes_icon.png";
import React from "react";
import { EnumRole } from "@src/types/role";
import { SelectWithSpinAndCustomMaxTag } from "../select/SelectWithCustomMaxTag";
import { Empty } from "antd";

type ProductInputProps = {
    onChange?: (value: string) => void;
    value?: string;
};
export const ProductInput: React.FC<ProductInputProps> = ({ onChange, value }) => {
    const { roles, isSuperAdmin } = useMe();

    const productCodesFiltered = roles.map((r: any) => r.productCode);
    const { data, isLoading } = useList<IProduct>({
        resource: "products",
        dataProviderName: "nestjsx",
        filters: !isSuperAdmin
            ? [
                  {
                      field: "code",
                      operator: "in",
                      value: productCodesFiltered,
                  },
              ]
            : [],
        queryOptions: {
            enabled: productCodesFiltered.length > 0,
        },
        pagination: {
            pageSize: 100,
        },
    });
    const products = (data?.data || []).map((item) => {
        return {
            ...item,
            productCode: item.code,
            icon: item.icon || AmanotesIcon,
        };
    });
    const renderLabelProduct = (product: any) => {
        return (
            <div className="flex items-center">
                <img src={product.icon} className="w-4 h-4 rounded-[2px] mr-2" />
                {product.name} - {product.productCode}
            </div>
        );
    };

    const options = React.useMemo(() => {
        return products.map((product) => {
            const role = roles.find((r: { productCode: string }) => r.productCode === product.code);
            const disabled = !isSuperAdmin && role.role === EnumRole.ProductViewer;
            return {
                label: renderLabelProduct(product),
                value: product.code,
                title: product.name,
                disabled,
            };
        });
    }, [products]);

    return (
        <SelectWithSpinAndCustomMaxTag
            options={options}
            loading={isLoading}
            placeholder="Select product"
            showSearch
            filterOption={(input, option) => {
                const { title, value } = option as any;
                if (!value || !title) return false;
                return (
                    title.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                    value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                );
            }}
            onChange={(value) => {
                onChange?.(value);
            }}
            allowClear
            style={{ width: 300 }}
            notFoundContent={
                <Empty className="text-[12px]" description="You are not in product! Please contact your admin" />
            }
        />
    );
};
